import { connect } from 'react-redux';
import * as SharedMaterialsDatabaseStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import { SharedMaterialRequestComponentBase, getSharedMaterialRequestState } from './SharedMaterialRequestComponentBase';

class RequestAccessToSharedMaterial extends SharedMaterialRequestComponentBase {
    protected renderForm(): JSX.Element {
        return <div></div>;
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected getLocalizedTitle() {
        return "";
    }

    // ===============================================================================

    protected getLocalizedDescription() {
        return "";
    }

    // ===============================================================================

    protected submitButton_click = () => {
    }
}

// ===============================================================================

export default connect(
    getSharedMaterialRequestState,
    SharedMaterialsDatabaseStateController.actionCreators // Selects which action creators are merged into the component's props
)(RequestAccessToSharedMaterial as any);